// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__12RcV","productName":"Table_productName__2jxAI"};